import { observer } from 'mobx-react-lite';

import { store } from 'store';

import * as S from './UpdateButton.styles';

export const UpdateButton = observer(() => {
  const { updateTimeSec, wowmaxResult, fetchWowmax, isSwapping, isWrapUnwrap } = store.swapStore;

  const canUpdateByClick =
    (wowmaxResult.data || wowmaxResult.isError) &&
    !wowmaxResult.isLoading &&
    !isSwapping &&
    !isWrapUnwrap;

  const canUpdateByTimer =
    wowmaxResult.data && !wowmaxResult.isLoading && !isSwapping && !isWrapUnwrap;

  return (
    <S.Root onClick={() => fetchWowmax(true)} disabled={!canUpdateByClick}>
      <S.Loader
        $updateTimeSec={canUpdateByTimer ? updateTimeSec : null}
        $isLoading={wowmaxResult.isLoading && !isWrapUnwrap}
      >
        <svg height="32" width="32">
          <circle cx="50%" cy="50%" r="50%" strokeWidth="100%" />
        </svg>
      </S.Loader>
    </S.Root>
  );
});
